import {Field} from 'formik';
import AddressComponent from '../AddressComponent';
import ErrorBoundary from '../ErrorBoundary';
import ConfirmPassword from '../ConfirmPassword';
import {formatPhoneNumber} from '../common';
import {useState} from 'react';

export default function PracticeDetails({ errors, touched, values, handleBlur, handleChange, setFieldValue }) {
    const [sameAsBilling, setSameAsBilling] = useState(true);
    const handleSameAsBilling = (e) => {
        var isBilling = e.target.checked;
        if (isBilling) {
            setSameAsBilling(true);
            return;
        }
        setSameAsBilling(false);
    }


    const handlePhoneNumInput = (e, setFieldValue) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        setFieldValue('phoneNo', formattedPhoneNumber);
    };



    const handleEINInput = (e, setFieldValue) => {
        const formattedEIN = formatEIN(e.target.value);
        setFieldValue('entityEin', formattedEIN);
    };

    function formatEIN(value) {
        if (!value) {
            return value;
        }

        const ein = value.replace(/[^\d]/g, '');
        if (ein.length < 3) {
            return ein;
        }

        return `${ein.slice(0, 2)}-${ein.slice(2, 9)}`;
    }
    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="entityName" className="block text-sm font-medium text-gray-700">Practice Name <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        <Field
                            name="entityName"
                            id="input_entityName"
                            required
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.entityName && touched.entityName ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors.entityName && touched.entityName ? (
                            <p className="mt-1 text-sm text-red-600">{errors.entityName}</p>
                        ) : null}
                    </div>
                </div>
                <div>
                    <label htmlFor="entityEin" className="block text-sm font-medium text-gray-700">EIN <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        <Field
                            name="entityEin"
                            id="input_entityEin"
                            required
                            onChange={(e) => handleEINInput(e, setFieldValue)}
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.entityEin && touched.entityEin ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors.entityEin && touched.entityEin ? (
                            <p className="mt-1 text-sm text-red-600">{errors.entityEin}</p>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        <Field
                            type="email"
                            id="input_entityEmail"
                            name="entityEmail"
                            required
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.entityEmail && touched.entityEmail ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors.entityEmail && touched.entityEmail ? (
                            <p className="mt-1 text-sm text-red-600">{errors.entityEmail}</p>
                        ) : null}
                    </div>
                </div>
                <div>
                    <label htmlFor="phoneNo" className="block text-sm font-medium text-gray-700">Phone Number <span className="text-red-500">*</span></label>
                    <div className="mt-1">
                        <Field
                            name="phoneNo"
                            id="input_phoneNo"
                            required
                            onChange={(e) => handlePhoneNumInput(e, setFieldValue)}
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.phoneNo && touched.phoneNo ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors.phoneNo && touched.phoneNo ? (
                            <p className="mt-1 text-sm text-red-600">{errors.phoneNo}</p>
                        ) : null}
                    </div>
                </div>
            </div>

            <div>
                <ConfirmPassword
                    errors={errors}
                    touched={touched}
                    handleBlur={handleBlur}
                    prefix={"add-practice"}
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="website" className="block text-sm font-medium text-gray-700">Website</label>
                    <div className="mt-1">
                        <Field
                            name="website"
                            id="input_website"
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.website && touched.website ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors.website && touched.website ? (
                            <p className="mt-1 text-sm text-red-600">{errors.website}</p>
                        ) : null}
                    </div>
                </div>
                <div>
                    <label htmlFor="npi" className="block text-sm font-medium text-gray-700">NPI</label>
                    <div className="mt-1">
                        <Field
                            name="npi"
                            id="input_npi"
                            className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${errors.npi && touched.npi ? 'border-red-500' : 'border-gray-300'}`}
                        />
                        {errors.npi && touched.npi ? (
                            <p className="mt-1 text-sm text-red-600">{errors.npi}</p>
                        ) : null}
                    </div>
                </div>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">Billing Address <span className="text-red-500">*</span></label>
                <div className="border-t border-gray-300 mt-2"></div>
            </div>
            <div>
                <ErrorBoundary>
                    <AddressComponent
                        errors={errors}
                        touched={touched}
                        values={values}
                        handleChange={handleChange}
                        prefix={'billAddr'}
                        handleBlur={handleBlur}
                    />
                </ErrorBoundary>
            </div>

            <div className="border-t border-gray-300"></div>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Mailing Address</label>
                <div className="flex items-center mb-4">
                    <input
                        type="checkbox"
                        className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
                        name="sameBilling"
                        onChange={(e) => { handleSameAsBilling(e) }}
                        checked={sameAsBilling}
                    />
                    <label className="ml-2 block text-sm text-gray-900">Same as Billing Address</label>
                </div>
                <ErrorBoundary>
                    {!sameAsBilling &&
                        <AddressComponent
                            disabled={sameAsBilling}
                            errors={errors}
                            touched={touched}
                            values={values}
                            handleChange={handleChange}
                            prefix={'mailAddr'}
                            handleBlur={handleBlur}
                        />}
                </ErrorBoundary>
            </div>

        </div>
    );
}